import { db } from "../../firebase";
import {
  collection,
  documentId,
  getDocs,
  query,
  where,
} from "firebase/firestore";

const GetLeadProperties = async (propertyId) => {
  /**
   * input: null
   * output: lead properties document / collection
   * description: get lead properties / get documents
   */

  try {
    const propertyCollection = await collection(db, "properties");

    const q = query(propertyCollection, where(documentId(), "in", propertyId));
    const leadPropertySnapshot = await getDocs(q);

    let leadProperties = [];

    leadPropertySnapshot.forEach((doc) => {
      leadProperties.push({ ...doc.data(), id: doc.id });
    });

    return leadProperties;
  } catch (error) {
    console.log(error);
  }
};

export default GetLeadProperties;
